import {useQueryClient} from '@tanstack/react-query'
import {useCallback} from 'react'
import {APIConfigType, ContextualPrefetchType} from 'interfaces'
import {prefetchConfig} from './prefetch.config'
import {reactQueryFetchFunctionMap, warmUpFunctionMap} from './prefetch.queryfn'
import {checkPermission, usePermissions} from 'rbac'

/**
 * @description A Hook to prefetch data on respective contexts
 * @returns prefetch function
 */
const useContextualPrefetch = () => {
  const queryClient = useQueryClient()
  const {permissions: userPermissions} = usePermissions()
  const prefetch = useCallback(
    ({route, context, payload}: ContextualPrefetchType) => {
      // TODO: Please check what's missing here and do the needful
      // @ts-ignore
      const config = prefetchConfig.contextual[route][context]

      if (!config) return

      config.forEach((apiConfig: APIConfigType) => {
        const {isReactQuery, reqPermissions} = apiConfig

        const hasPermission = checkPermission(reqPermissions, userPermissions)
        if (!hasPermission) return

        if (isReactQuery) {
          const {queryKey, queryFnName} = apiConfig
          const data = queryClient.getQueryData(queryKey)

          if (!data) {
            // @ts-ignore
            const fetchFunction = reactQueryFetchFunctionMap[queryFnName]
            // @ts-ignore
            fetchFunction(queryClient, queryKey, payload[queryFnName])
          }
        } else {
          const {id} = apiConfig
          // @ts-ignore
          warmUpFunctionMap[id](payload[id])
        }
      })
    },
    [userPermissions],
  )

  return {prefetch}
}

export default useContextualPrefetch
